import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DndModule, DragDropConfig, DragDropService } from 'ng2-dnd';
import { CalendarModule } from 'primeng/calendar';
import { ChartsModule } from 'ng2-charts';

import { DatePipe, DecimalPipe, CurrencyPipe } from '@angular/common';
import { DistinctPipe } from './pipe/distinct.pipe';
import { GroupByPipe } from './pipe/group.pipe';
import { SumPipe } from './pipe/sum.pipe';
import { AggrPipe } from './pipe/aggr.pipe';
import { FormatPipe } from './pipe/format.pipe';
import { SortPipe } from './pipe/sort.pipe';

import { MDGToolBarComponent } from './component/toolbar/mdg.toolbar';
import { MDGFilterComponent } from './Component/Filter/MDG.Filter';
import { MDGDateFilterComponent } from './Component/Filter/MDG.DateFilter';
import { MDGPivotDrawerComponent } from './component/pivot/mdg.pivotdrawer';
import { MDGFormulaSelectorComponent } from './component/formula/mdg.formulaselector';
import { MDGFormulaComponent } from './component/toolbar/mdg.formula';
import { MDGDetailComponent } from './Component/detail/MDG.Detail';
import { MDGColumnsComponent } from './Component/detail/MDG.Columns';
import { MDGFormatComponent } from './component/toolbar/mdg.format';
import { MDGFormatterComponent } from './component/toolbar/mdg.formatter';
import { MDGSaveComponent } from './component/toolbar/mdg.save';

import { HelperService } from './Services/Helper.Service';
import { MdgPivotComponent } from './mdg-pivot.component';

const providers = [
  DistinctPipe,
  DecimalPipe,
  CurrencyPipe,
  DatePipe,
  SortPipe,
  GroupByPipe,
  SumPipe,
  AggrPipe,
  FormatPipe,
  DragDropService,
  DragDropConfig,
  HelperService
];

@NgModule({
  declarations: [
    MdgPivotComponent,
    MDGToolBarComponent,
    MDGFilterComponent,
    MDGDateFilterComponent,
    MDGPivotDrawerComponent,
    MDGFormulaComponent,
    MDGFormulaSelectorComponent,
    MDGDetailComponent,
    MDGColumnsComponent,
    MDGFormatComponent,
    MDGFormatterComponent,
    MDGSaveComponent,
    DistinctPipe,
    GroupByPipe,
    SumPipe,
    SortPipe,
    AggrPipe,
    FormatPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ChartsModule,
    DndModule,
    CalendarModule
  ],
  providers: providers,
  exports: [
    MdgPivotComponent
  ]
})
export class MdgPivotModule {
  // static forRoot(): ModuleWithProviders<MdgPivotModule> {
  //   return {
  //     ngModule: MdgPivotModule,
  //     providers: providers
  //   };
  // }
}
